export const CHAT_BANNER_STYLES = ['compact', 'image', 'full'] as const
export const CHAT_BANNER_POSITIONS = ['top', 'bottom'] as const
export const CHAT_BANNER_BUTTON_SIZES = ['small', 'medium', 'large'] as const
export const CHAT_BANNER_ACTIONS = ['link', 'booking'] as const
export const CHAT_BANNER_EVENTS = ['banner_viewed', 'banner_clicked', 'banner_closed'] as const
export const CHAT_BANNER_CLICKED_PARTS = ['button', 'banner'] as const

const COMPACT_RATIOS = ['1:1', '4:3', '16:9', '2:1'] as const
const WIDE_RATIOS = ['8:1', '6:1', '4:1'] as const
export const CHAT_BANNER_RATIOS = [...COMPACT_RATIOS, ...WIDE_RATIOS] as const
export const CHAT_BANNER_RATIOS_BY_STYLE = {
  compact: COMPACT_RATIOS,
  image: WIDE_RATIOS,
  full: WIDE_RATIOS,
} satisfies Record<(typeof CHAT_BANNER_STYLES)[number], readonly string[]>

export const CHAT_BANNER_IMAGE_RATIOS = Object.fromEntries(
  CHAT_BANNER_RATIOS.map((ratio) => {
    const [width = 1, height = 1] = ratio.split(':').map(Number)
    return [ratio, width / height]
  }),
) as Record<(typeof CHAT_BANNER_RATIOS)[number], number>

// Wide banners use the default thumbnail ratio when they collapse to Compact.
export const CHAT_BANNER_COMPACT_FALLBACK_RATIO = '16:9' satisfies (typeof COMPACT_RATIOS)[number]
export const CHAT_BANNER_BUTTON_FONT_SIZE = { small: 12, medium: 13, large: 14 } satisfies Record<
  (typeof CHAT_BANNER_BUTTON_SIZES)[number],
  number
>
export const CHAT_BANNER_THUMB_HEIGHT = { small: 36, medium: 48, large: 64 }
